import React from 'react';
import PropTypes from 'prop-types';
import css from './AccessDenied.scss';

// Error page when an authenticated user does not have access to the requested resource.
const AccessDenied = ({error}) => (
    <div className={css['container']}>
        <img src="../images/alert.svg" />
        <h1>{error}</h1>
        <p>Contact your institution’s technical support if you have questions.</p>
  </div>
);

AccessDenied.defaultProps = {
    error: 'You do not have permission to see this page.'
}

AccessDenied.propTypes = {
    error: PropTypes.string
}

export default AccessDenied;
